import gql from 'graphql-tag';

export const mutation = gql`
  mutation setMyFavs($deptIds: [String]!) {
    setMyFavs(myDepartmentIds: $deptIds) {
      id
      myDepartmentIds
    }
  }
`;
